<template>
    <div style="height: 100%; padding-bottom: 18px">
        <div class="sa-accordion-wrapper">
            <!-- <b-tabs id="tabsRsaDimissioneTrasferimento" ref="tabsRsaDimissioneTrasferimento" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" @input="onInputTabs" style="height: 100%; padding-bottom: 25px"> -->
            <b-tabs id="tabsRsaDimissioneTrasferimento" ref="tabsRsaDimissioneTrasferimento" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
                <b-tab title="Dimissione/Trasferimento" id="tbDimissioneTrasferimento">
                    <!-- vertical sa-tab-items-aree sa-tab-items-vertical -->
                    <form>
                        <div class="sa-accordion">
                            <input class="sa-accordion-input" type="radio" name="dimissione-trasferimento-radio-a" id="dimissione-trasferimento-radio-a" value="1" checked="checked" />
                            <label class="sa-accordion-label" for="dimissione-trasferimento-radio-a">
                                <!--   Dimissione/Trasferimento -->

                                <b-button variant="success secondary-noborder pull-right sa-accordion-btn" @click="onSave" :disabled="isDimissioneTrasferimento" v-if="!disableCampi">
                                    <b-icon icon="check2"></b-icon>
                                    <span style="padding-left: 5px"> {{ buttonText }}</span>
                                </b-button>
                                <b-button variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onModifica" :hidden="btnModificaDimissionetrasferimento">
                                    <b-icon icon="pencil"></b-icon>
                                    <span style="padding-left: 5px">Modifica</span>
                                </b-button>
                                <b-button variant="outline-danger outline-secondary-noborder pull-right sa-accordion-btn" @click="onAnnulla" :hidden="btnAnnullaDimissionetrasferimento">
                                    <b-icon icon="x"></b-icon>
                                    <span style="padding-left: 5px">Annulla</span>
                                </b-button>
                                <b-button v-if="isBtnStampa" variant="outline-purple outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickStampa()">
                                    <b-icon icon="printer" />
                                    <span style="padding-left: 5px">Stampa</span>
                                </b-button>
                                <b-button v-b-tooltip.hover title="Allegati" variant="outline-success outline-secondary-noborder pull-right sa-accordion-btn" @click="onClickVisualizzaAllegati(jsonData)" :hidden="btnAllegati">
                                    <b-icon icon="file-earmark-plus"></b-icon>
                                    <span style="padding-left: 5px">Allegati</span>
                                </b-button>
                            </label>
                            <div class="sa-accordion-content sa-tab-scroll ml-3 mr-3">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" :md="enableRsaCampiDimissioneAggiuntivi ? 4 : 6" :lg="enableRsaCampiDimissioneAggiuntivi ? 4 : 6" :xl="enableRsaCampiDimissioneAggiuntivi ? 4 : 6">
                                        <label class="sa-label-data">Numero Cartella</label>
                                        <b-form-input v-model="jsonData.numeroCartella" disabled></b-form-input>
                                    </b-col>
                                    <b-col v-if="enableRsaCampiDimissioneAggiuntivi" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Reparto dimissione</label>
                                        <b-form-input :value="getDescrizioneRepartoDimissione(jsonData.repartoDimissione)" disabled></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" :md="enableRsaCampiDimissioneAggiuntivi ? 4 : 6" :lg="enableRsaCampiDimissioneAggiuntivi ? 4 : 6" :xl="enableRsaCampiDimissioneAggiuntivi ? 4 : 6">
                                        <label class="sa-label-data">Stato:</label>
                                        <b-form-select v-model="jsonData.statoAttuale" value-field="value" text-field="text" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="statoOptions" :disabled="disableCampi" @change="onChangeStatoAttuale">
                                            <template #first>
                                                <b-form-select-option :value="''" disabled> - Seleziona Opzione - </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <!-- </b-card> -->
                                <!-- <b-card v-if="jsonData.statoAttuale === 'DIMESSO'" class="sa-card" header="Dimissione" header-tag="header" footer-tag="footer" title=""> -->
                                <b-row v-if="jsonData.statoAttuale === 'DIMESSO'">
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Data Ora Dimissioni:</label>
                                        <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataOraDimissioneTradferimento" type="datetime" :disabled="disableCampi" :disabled-date="notAfter"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Motivo:</label>
                                        <b-form-select v-model="jsonData.dimissioneMotivoDimissione" value-field="voce" text-field="voce" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="motiviDimissioneOptions" :disabled="disableCampi">
                                            <template #first>
                                                <b-form-select-option :value="''" disabled> - Seleziona Valore - </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <!-- <b-form-select v-model="jsonData.dimissioneMotivoDimissione" value-field="value" text-field="text" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="motiviDimissioneOptions" :disabled="disableCampi"></b-form-select> -->
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Altro Motivo</label>
                                        <b-form-input v-model="jsonData.dimissioneMotivoDimissioneAltro" :disabled="jsonData.dimissioneMotivoDimissione !== 'ALTRO' || disableCampi"></b-form-input>
                                    </b-col>
                                    <b-col v-if="enableRsaCampiDimissioneAggiuntivi" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <label class="sa-label-data">Modalità dimissione riabilitativa</label>
                                        <b-form-select v-model="jsonData.modalitaDimissioneRiabilitativa" value-field="descrizione" text-field="descrizione" class="mb-2 mr-sm-2 mb-sm-0" :options="modalitaDimissioneRiabilitativaOptions" :disabled="disableCampi">
                                            <template #first>
                                                <b-form-select-option :value="null">- Seleziona Valore -</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col v-if="enableRsaCampiDimissioneAggiuntivi" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-input-group class="mb-3">
                                            <label class="sa-label-data">Diagnosi amministrativa di dimissione ICD9</label>
                                            <b-button variant="" :disabled="disableCampi" title="Cerca diagnosi ICD9" aria-label="Cerca diagnosi ICD9" @click="onClickSearchIcdix">
                                                <b-icon icon="search"></b-icon>
                                            </b-button>
                                        </b-input-group>
                                        <b-form-textarea v-model="jsonData.diagnosiAmministrativaDimissione" placeholder="" rows="7" :disabled="disableCampi"></b-form-textarea>
                                    </b-col>
                                    <b-col v-if="enableRsaCampiDimissioneAggiuntivi" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Lateralità</label>
                                        <b-form-select v-model="jsonData.lateralita" value-field="value" text-field="text" class="mb-2 mr-sm-2 mb-sm-0" :options="lateralitaOptions" :disabled="disableCampi"></b-form-select>
                                    </b-col>
                                    <b-col v-if="enableRsaCampiDimissioneAggiuntivi" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Presente al ricovero</label>
                                        <b-form-select v-model="jsonData.presenteAlRicovero" value-field="value" text-field="text" class="mb-2 mr-sm-2 mb-sm-0" :options="siNoOptions" :disabled="disableCampi"></b-form-select>
                                    </b-col>
                                    <b-col v-if="enableRsaCampiDimissioneAggiuntivi" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="d-flex justify-content-end mt-2">
                                        <b-button variant="outline-primary" @click="onClickDiagnosiConcomitanti">
                                            <b-icon icon="list-ul"></b-icon>
                                            {{ disableCampi ? "Lista diagnosi" : "Diagnosi concomitanti" }}
                                        </b-button>
                                    </b-col>
                                    <b-col v-if="enableRsaDimissioneGestioneAssistenza" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Gestione Farmaci</label>
                                        <b-form-select v-model="jsonData.dimissioneGestioneFarmaci" value-field="value" text-field="text" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="gestioneFamaciOptions" :disabled="disableCampi"></b-form-select>
                                    </b-col>
                                    <b-col v-if="enableRsaDimissioneGestioneAssistenza" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Gestione Ausili</label>
                                        <b-form-select v-model="jsonData.dimissioneGestioneAusili" value-field="value" text-field="text" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="gestioneAusiliOptions" :disabled="disableCampi"></b-form-select>
                                    </b-col>
                                    <b-col v-if="enableRsaDimissioneGestioneAssistenza" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <b-form-checkbox class="sa-custom-switch" v-model="jsonData.dimissionePazienteAssenteGiorniSelezionato" switch :disabled="disableCampi">
                                            <label class="sa-label-data-check">Considera il paziente assente nel giorno selezionato</label>
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <label class="sa-label-data">Annotazioni:</label>
                                        <b-form-textarea id="textarea-no-resize" v-model="jsonData.note" rows="3" no-resize :readonly="disableCampi"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <!-- </b-card> -->
                                <!-- <b-card v-if="jsonData.statoAttuale === 'TRASFERITO'" class="sa-card" header="Trasferimento" header-tag="header" footer-tag="footer" title=""> -->
                                <b-row v-if="jsonData.statoAttuale === 'TRASFERITO'">
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Regime Ricovero</label>
                                        <b-form-input v-model="jsonData.trasferimentoRegimeRicovero" disabled></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Struttura Attuale</label>
                                        <b-form-input v-model="jsonData.trasferimentoStrutturaAttuale" disabled></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Struttura Trasferimento</label>
                                        <!--              <b-form-input v-model="jsonData.trasferimentoStrutturaTrasmetimento" :disabled="disableCampi"></b-form-input> -->
                                        <b-form-select v-model="jsonData.trasferimentoStrutturaTrasmetimento" value-field="codiceStruttura" text-field="denominazione" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="struttureOptions" :disabled="disableCampi" @change="onChangeStrutturaTrasferimento"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Altra Struttura Codice</label>
                                        <b-form-input v-model="jsonData.trasferimentoStrutturaTrasmetimentoCodice" :disabled="disableCampi"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Presidio Trasferimento</label>
                                        <b-form-select v-model="jsonData.trasferimentoIdPresidio" value-field="id" text-field="denominazione" value="''" class="mb-2 mr-sm-2 mb-sm-0" :options="presidiOptions" :disabled="disableCampi" @change="onChangePresidio"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label>Regime<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.regime" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="codice" text-field="descrizione" :options="regimiOptions"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label>{{ getLabelTraduora("nurity.accettazione.setting") }}</label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.settingCodice" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="codice" text-field="setting" :options="settingsPresidiOptions" @change="onChangeSettingCodice">
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label>Livello</label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idSettingLivello" class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="id" text-field="descrizione" :options="settingLivelliOptions" @change="onChangeRsaSettingLivelli"> </b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Data Ora Trasferimento:</label>
                                        <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataOraDimissioneTradferimento" type="datetime" :disabled="disableCampi" :disabled-date="notAfter"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <b-form-checkbox class="sa-custom-switch" v-model="jsonData.trasferimentoChiusuraImpegnativa" switch :disabled="disableCampi">
                                            <label class="sa-label-data-check">Chiudi l'impegnativa nella data di trasferimento</label>
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <label class="sa-label-data">Annotazioni:</label>
                                        <b-form-textarea id="textarea-no-resize" v-model="jsonData.note" rows="3" no-resize></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </form>
                </b-tab>
                <b-tab title="Storico" id="tbDimissioneTrasferimentoStorico">
                    <form>
                        <rsa-scheda-ospiste-dimissione-trasferimento-storico-component ref="cmpRsaDimissioneTrasferimentoStoricoComponent"></rsa-scheda-ospiste-dimissione-trasferimento-storico-component>
                    </form>
                </b-tab>
            </b-tabs>
            <!-- <b-tabs vertical id="tabsRsaPazienteAreeView" ref="tabsRsaPazienteAreeView" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items sa-tab-items-aree sa-tab-items-vertical" content-class="mt-3" class="sa-tab" style="padding-bottom: 25px" fill @input="onInputTabs">
        <b-tab title="Nome"> </b-tab>
      </b-tabs> -->
            <!-- </b-card> -->
            <b-modal scrollable b-modal title="Modifica Dimissione/Trasferimento" ref="mdlDimissioniTrasferimentiStato" id="mdlDimissioniTrasferimentiStato" size="md" centered no-close-on-backdrop no-close-on-esc hide-header-close @show="onShowModalStorico" @ok="onCloseModalDimissioniTrasferimentiStato">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label>Stato</label>
                        <b-form-select v-model="dimissisoneTrasferimentiStatoStorico.stato" value-field="value" text-field="text" :value="null" class="mb-2 mr-sm-2 mb-sm-0" :options="dimissisoneTrasferimentiStatoOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Motivazione:</label>
                        <b-form-textarea id="textarea-no-resize" v-model="dimissisoneTrasferimentiStatoStorico.motivazione" rows="5" no-resize></b-form-textarea>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
        <b-modal ref="mdlListaAllegati" id="mdlListaAllegati" size="xl" style="height: 100%" no-close-on-backdrop no-close-on-esc hide-header-close>
            <allegato-model-component v-if="modalStep === 0" :idPaziente="idAccettazione" :idRisorsa="jsonData.id" @updateFiles="onUpdateFile()" :jsonData="jsonData" tipoDocumento="IMPEGNATIVA"></allegato-model-component>
            <paziente-allegati-edit-component v-if="modalStep === 1" :jsonData="data" :tipoRisorsa="'IMPEGNATIVA'"></paziente-allegati-edit-component>
            <template #modal-footer>
                <b-button v-if="modalStep === 1" size="md" class="no-text" variant="outline-danger" @click="onClickUndo">Annulla</b-button>
                <b-button v-if="modalStep === 1" @click="onSalvaRichiesta" :disabled="modalStep !== 1" variant="outline-success">Salva</b-button>
                <b-button v-if="modalStep === 0" @click="onClickAddAllegati" variant="outline-success">Aggiungi</b-button>
                <b-button v-if="modalStep === 0" @click="onClickOk" variant="outline-primary">Chiudi</b-button>
            </template>
        </b-modal>
        <rsa-assegna-posto-letto-modal-edit-component ref="cmpAccettazionePostiLettoModalEdit" :isTrasferimentoPaziente="true" @updateAccettazionePostoLetto="onUpdateAccettazionePostoLetto"></rsa-assegna-posto-letto-modal-edit-component>
        <print-component v-show="false" ref="cmpPrint"></print-component>
        <diagnosi-icd-ix-component v-if="enableRsaCampiDimissioneAggiuntivi" v-show="false" ref="cmpDiagnosiIcdIx" @onModalClose="onModalDiagnosiIcdIxClose"></diagnosi-icd-ix-component>
        <rsa-diagnosi-concomitanti-modal-component v-if="enableRsaCampiDimissioneAggiuntivi" ref="cmpDiagnosiConcomitanti" :isReadOnly="disableCampi" @onSearchDiagnosi="onSearchDiagnosiConcomitante" @onConfirm="onConfermaDiagnosiConcomitanti" @onClose="indiceDiagnosiConcomitante = null"></rsa-diagnosi-concomitanti-modal-component>
    </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import AllegatoModelComponent from "../../../utility/components/AllegatoModelComponent.vue";
import RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent from "./RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent.vue";
import RsaAssegnaPostoLettoModalEditComponent from "../../rsaaccettazione/components/RsaAssegnaPostoLettoModalEditComponent.vue";
import PazienteAllegatiEditComponent from "../../../paziente/allegati/components/PazienteAllegatiEditComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import DiagnosiIcdIxComponent from "../../../utility/components/DiagnosiIcdIxComponent.vue";
import RsaDiagnosiConcomitantiModalComponent from "./RsaDiagnosiConcomitantiModalComponent.vue";

export default {
    props: {
        jsonDataAccettazione: { type: Object },
        utente: { type: Object },
    },
    components: {
        DatePicker,
        RsaSchedaOspisteDimissioneTrasferimentoStoricoComponent,
        PrintComponent,
        RsaAssegnaPostoLettoModalEditComponent,
        AllegatoModelComponent,
        PazienteAllegatiEditComponent,
        DiagnosiIcdIxComponent,
        RsaDiagnosiConcomitantiModalComponent,
    },
    mixins: [UtilityMixin],
    watch: {
        "jsonData.statoAttuale": function (value) {
            let me = this;

            //if (me.disableCampi) {
            me.setIsDimissioneTrasferimeto(value);
            //}
        },
        /*   jsonData: {
            handler(value) {
                console.log(value);
            },
            deep: true,
        }, */
    },
    computed: {
        lateralitaOptions() {
            return [...this.siNoOptions, { value: "N/A", text: "N/A" }];
        },
        buttonText() {
            switch (this.jsonData.statoAttuale) {
                case "DIMESSO":
                    return "Dimetti";
                case "TRASFERITO":
                    return "Trasferisci";
                default:
                    return "Dimetti/Trasferisci";
            }
        },
    },
    data() {
        return {
            pathResource: "/rsadimissionitrasferimenti",
            pathResourceAccettazione: "/rsaaccettazioni",
            pathResourceAllegati: "/allegati",
            pathResourceGestioneFarmaciAusili: "/rsadimissionigestioneausili",
            pathResourceDimissioniTrasferimentiStati: "/rsadimissionitrasferimentistati",
            pathResourceDiagnosiConcomitanti: "/dimissionitrasferimentidiagnosiconcomitanti",
            pathResourceModalitaDimissioneRiabilitativa: "/modalitadimissioniriabilitativa",
            pathResourceDizionario: "/rsadizionario",
            pathResourcePresidi: "/strutturepresidi",
            data: { dataCaricamento: new Date().getTime(), idAnagrafica: null, idRisorsa: null },
            pathResourceStrutture: "/strutture",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            pathResourceRegimi: "/accettazioneregimi",
            pathResourceSettingLivelli: "/rsasettinglivelli",
            enableRsaCampiDimissioneAggiuntivi: this.appConfig.enableRsaCampiDimissioneAggiuntivi === true,
            enableRsaDimissioneGestioneAssistenza: this.appConfig.enableRsaDimissioneGestioneAssistenza === true,
            disableCampi: true,
            btnModificaDimissionetrasferimento: true,
            btnAnnullaDimissionetrasferimento: true,
            btnAllegati: true,
            activeTabIndex: 0,
            modalStep: 0,
            idAccettazione: null,
            isDimissioneTrasferimento: true,
            isBtnStampa: false,
            indiceDiagnosiConcomitante: null,
            jsonData: {
                id: null,
                idPaziente: "",
                statoAttuale: "",
                statoDataOra: new Date().getTime(),
                dataOraDimissioneTradferimento: null,
                dimissioneMotivoDimissione: "",
                dimissioneGestioneFarmaci: "",
                dimissioneGestioneAusili: "",
                dimissionePazienteAssenteGiorniSelezionato: false,
                trasferimentoRegimeRicovero: "",
                trasferimentoStrutturaAttuale: "",
                trasferimentoStrutturaTrasmetimento: "",
                trasferimentoStrutturaTrasmetimentoNome: "",
                trasferimentoStrutturaTrasmetimentoCodice: "",
                dimissioneMotivoDimissioneAltro: "",
                modalitaDimissioneRiabilitativa: null,
                diagnosiAmministrativaDimissione: "",
                listaDiagnosiConcomitanti: [],
                lateralita: null,
                presenteAlRicovero: null,
                trasferimentoChiusuraImpegnativa: "",
                trasferimentoIdPresidio: null,
                numeroCartella: "",
                repartoDimissione: null,
                storico: [],
                lettoAccettazioneBean: {},
                regime: null,
                settingCodice: null,
                idSettingLivello: null,
            },
            dimissisoneTrasferimentiStatoStorico: { stato: null, motivazione: "", statoDataOra: null },
            statoOptions: [
                { value: "DIMESSO", text: "DIMESSO" },
                { value: "TRASFERITO", text: "TRASFERITO" },
            ],
            dimissisoneTrasferimentiStatoOptions: [],
            motiviDimissioneOptions: [],
            modalitaDimissioneRiabilitativaOptions: [],
            repartoDimissioneOptions: [
                { codice: 1, descrizione: "NEUROLOGIA" },
                { codice: 2, descrizione: "ORTOPEDIA" },
                { codice: 3, descrizione: "PNEUMOLOGIA" },
                { codice: 4, descrizione: "CARDIOLOGIA" },
                { codice: 5, descrizione: "GERIATRIA" },
            ],
            siNoOptions: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "SI", text: "Sì" },
                { value: "NO", text: "No" },
            ],
            gestioneFamaciOptions: [],
            gestioneAusiliOptions: [],
            presidiOptions: [{ id: null, denominazione: "- Seleziona Valore -" }],
            struttureOptions: [],
            regimiOptions: [],
            settingsPresidiOptions: [],
            settingLivelliOptions: [{ id: null, descrizione: "- Seleziona Valore -" }],
        };
    },
    mounted() {},
    methods: {
        setId(id) {
            let me = this;
            me.idAccettazione = id;
            me.loadDizionarioData();
            if (me.enableRsaDimissioneGestioneAssistenza) {
                me.loadGestioneFarmaciAusili();
            }
            me.loadDimissioniTrasferimentiStati();
            if (me.enableRsaCampiDimissioneAggiuntivi) {
                me.loadModalitaDimissioneRiabilitativa();
            }
            me.loadRegimi();
            me.loadData();
        },

        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            let filtro = { page: 1, forPage: 1, idAccettazione: me.idAccettazione };
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: filtro })
                .then((response) => {
                    me.isBtnStampa = false;
                    if (response.data.data.recordsNumber > 0) {
                        if (response.data.data.list[0].statoAttuale === "ANNULLATO") {
                            me.nuovaDimissioneTrasferimento();
                            me.jsonData.id = response.data.data.list[0].id;
                            me.jsonData.statoAttuale = "";
                            //  me.jsonData.numeroCartella = response.data.data.list[0].numeroCartella;
                            me.disableCampi = false;
                            me.btnModificaDimissionetrasferimento = true;
                            me.btnAnnullaDimissionetrasferimento = true;
                            me.btnAllegati = true;
                        } else {
                            me.jsonData = response.data.data.list[0];
                            me.isBtnStampa = true;
                            me.disableCampi = true;
                            me.setIsDimissioneTrasferimeto(me.jsonData.statoAttuale);
                            me.btnModificaDimissionetrasferimento = false;
                            me.btnAnnullaDimissionetrasferimento = false;
                            me.btnAllegati = false;
                        }
                    } else {
                        me.disableCampi = false;
                        me.btnModificaDimissionetrasferimento = true;
                        me.btnAnnullaDimissionetrasferimento = true;
                        me.btnAllegati = true;
                        me.nuovaDimissioneTrasferimento();
                    }
                    if (me.enableRsaCampiDimissioneAggiuntivi) {
                        me.loadRepartoDimissione();
                    }
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch((error) => {
                    this.$emit("afterLoadData");
                    this.errorToast(error);
                });
        },
        nuovaDimissioneTrasferimento() {
            let me = this;
            me.$set(me.jsonData, "modalitaDimissioneRiabilitativa", null);
            me.$set(me.jsonData, "diagnosiAmministrativaDimissione", "");
            me.$set(me.jsonData, "listaDiagnosiConcomitanti", []);
            me.$set(me.jsonData, "repartoDimissione", null);
            me.$set(me.jsonData, "lateralita", null);
            me.$set(me.jsonData, "presenteAlRicovero", null);
            me.jsonData.idAccettazione = me.jsonDataAccettazione.id;
            me.jsonData.idPaziente = me.jsonDataAccettazione.accettazioneAnagrafica.id;
            me.jsonData.numeroCartella = me.jsonDataAccettazione.numero;
            me.jsonData.trasferimentoRegimeRicovero = me.jsonDataAccettazione.regime;
            me.jsonData.trasferimentoStrutturaAttuale = me.jsonDataAccettazione.accettazioneStruttura.denominazione;
        },
        /* loadMotivoDimissione() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceMotiviDimissione;
            me.motiviDimissioneOptions = [];
            me.$emit("beforeLoadData");
            axios
                .get(link)
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        me.motiviDimissioneOptions.push({ value: element.descrizione, text: element.descrizione });
                    });
                    me.motiviDimissioneOptions.unshift({ value: "", text: "-Seleziona Valore-" });
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
 */
        loadDizionarioData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDizionario, null, me.loadDizionarioDataSuccess, me.loadDizionarioDataError);
        },

        loadDizionarioDataSuccess(response) {
            let me = this;
            if (response.data?.data?.list) {
                me.motiviDimissioneOptions = response.data.data.list.filter((item) => item.tipo === "MOTIVAZIONE_DIMISSIONE_TRASFERIMENTO");
            }
        },
        loadDizionarioDataError(error) {
            console.error("Errore nel caricamento delle motivazioni", error);
        },
        loadModalitaDimissioneRiabilitativa() {
            let me = this;
            me.loadDataResources(me.pathResourceModalitaDimissioneRiabilitativa, {}, me.resultResponseModalitaDimissioneRiabilitativa, null);
        },
        resultResponseModalitaDimissioneRiabilitativa(response) {
            let me = this;
            me.modalitaDimissioneRiabilitativaOptions = response.data.data.list;
        },
        loadRepartoDimissione() {
            let me = this;
            if (!me.enableRsaCampiDimissioneAggiuntivi || me.idAccettazione === null || me.idAccettazione === undefined || me.idAccettazione === "") {
                return;
            }
            me.loadDataResources(me.pathResourceAccettazione + "/" + me.idAccettazione, {}, me.resultResponseRepartoDimissione, null);
        },
        resultResponseRepartoDimissione(response) {
            let me = this;
            me.$set(me.jsonData, "repartoDimissione", response.data.data.accettazioneAnagrafica.repartoAmmissione);
        },
        getDescrizioneRepartoDimissione(codice) {
            let me = this;
            let reparto = me.repartoDimissioneOptions.find((element) => element.codice === Number(codice));
            return reparto ? reparto.descrizione : codice;
        },
        onClickSearchIcdix() {
            let me = this;
            if (me.disableCampi || !me.enableRsaCampiDimissioneAggiuntivi || me.jsonData.statoAttuale !== "DIMESSO") {
                return;
            }
            me.indiceDiagnosiConcomitante = null;
            me.$refs.cmpDiagnosiIcdIx.onClickBtnRicercaIcdIx();
        },
        onModalDiagnosiIcdIxClose(selectedElement) {
            let me = this;
            let diagnosi = selectedElement[0] && selectedElement[0][0];
            if (!diagnosi || !diagnosi.codiceIcdix || me.disableCampi || !me.enableRsaCampiDimissioneAggiuntivi || me.jsonData.statoAttuale !== "DIMESSO") {
                return;
            }
            if (me.indiceDiagnosiConcomitante !== null) {
                me.$refs.cmpDiagnosiConcomitanti.setDiagnosiIcdix(me.indiceDiagnosiConcomitante, diagnosi);
                me.indiceDiagnosiConcomitante = null;
            } else {
                me.$set(me.jsonData, "diagnosiAmministrativaDimissione", "(" + diagnosi.codiceIcdix + ") " + diagnosi.descrizioneIcdix);
            }
        },
        onClickDiagnosiConcomitanti() {
            if (!this.enableRsaCampiDimissioneAggiuntivi || this.jsonData.statoAttuale !== "DIMESSO") {
                return;
            }
            this.indiceDiagnosiConcomitante = null;
            if (this.disableCampi) {
                this.loadDiagnosiConcomitanti();
                return;
            }
            this.$refs.cmpDiagnosiConcomitanti.show(this.jsonData.listaDiagnosiConcomitanti);
        },
        loadDiagnosiConcomitanti() {
            let me = this;
            if (me.jsonData.id === null || me.jsonData.id === undefined || me.jsonData.id === "") {
                return;
            }
            let filtro = { page: 1, forPage: 50, idDimissioneTrasferimento: me.jsonData.id };
            me.$emit("beforeLoadData");
            me.loadDataResources(me.pathResourceDiagnosiConcomitanti, filtro, me.resultResponseDiagnosiConcomitanti, me.resultErrorDiagnosiConcomitanti);
        },
        resultResponseDiagnosiConcomitanti(response) {
            this.$set(this.jsonData, "listaDiagnosiConcomitanti", response.data.data.list);
            this.$emit("afterLoadData");
            this.$refs.cmpDiagnosiConcomitanti.show(this.jsonData.listaDiagnosiConcomitanti);
        },
        resultErrorDiagnosiConcomitanti(error) {
            this.$emit("afterLoadData");
            this.errorToast(error);
        },
        onSearchDiagnosiConcomitante(index) {
            if (this.disableCampi || !this.enableRsaCampiDimissioneAggiuntivi || this.jsonData.statoAttuale !== "DIMESSO") {
                return;
            }
            this.indiceDiagnosiConcomitante = index;
            this.$refs.cmpDiagnosiIcdIx.onClickBtnRicercaIcdIx();
        },
        onConfermaDiagnosiConcomitanti(items) {
            if (this.disableCampi || !this.enableRsaCampiDimissioneAggiuntivi || this.jsonData.statoAttuale !== "DIMESSO") {
                return;
            }
            this.$set(this.jsonData, "listaDiagnosiConcomitanti", items);
        },

        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaDimissioneTrasferimento.getTabs()[index];
            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            switch (idActiveTab) {
                case "tbDimissioneTrasferimentoStorico":
                    me.$refs.cmpRsaDimissioneTrasferimentoStoricoComponent.loadData(me.jsonData.id);
                    break;
            }
            //  this.$emit("onActiveTab", idActiveTab);
        },
        loadGestioneFarmaciAusili() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceGestioneFarmaciAusili;
            me.gestioneFamaciOptions = [];
            me.gestioneAusiliOptions = [];
            me.$emit("beforeLoadData");
            axios
                .get(link)
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        switch (element.tipoGestione) {
                            case "FARMACI":
                                me.gestioneFamaciOptions.push({ value: element.descrizione, text: element.descrizione });
                                break;
                            case "AUSILI":
                                me.gestioneAusiliOptions.push({ value: element.descrizione, text: element.descrizione });
                                break;
                        }
                    });
                    me.gestioneFamaciOptions.unshift({ value: "", text: "- Seleziona Valore -" });
                    me.gestioneAusiliOptions.unshift({ value: "", text: "- Seleziona Valore -" });
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onSave() {
            /* let me = this;
            if (!me.jsonData.id === null) {
                me.dimissisoneTrasferimentiStatoStorico = {
                    stato: "CONFERMATO",
                    motivazione: me.jsonData.motivazione,
                    statoDataOra: new Date().getTime(),
                };
                if (!me.jsonData.storico) {
                    me.jsonData.storico = [];
                }

                me.jsonData.storico.push(me.dimissisoneTrasferimentiStatoStorico);
                me.saveDimissionieTrasferimento();
            } else {
                if (!me.btnModificaDimissionetrasferimento) {
                    me.$refs.mdlDimissioniTrasferimentiStato.show();
                } else {
                    me.updateDimissioneeTrasferimento();
                }
            } */

            let me = this;
            if (me.jsonData.id === null) {
                /* me.dimissisoneTrasferimentiStatoStorico = {
                    stato: "CONFERMATO",
                    motivazione: "DIMISSIONE",
                    statoDataOra: new Date().getTime(),
                };
                me.jsonData.storico.push(me.dimissisoneTrasferimentiStatoStorico); */
                if (me.jsonData.statoAttuale === "TRASFERITO") {
                    let me = this;
                    me.jsonDataAccettazione.idPresidio = me.jsonData.trasferimentoIdPresidio;
                    me.jsonDataAccettazione.sesso = me.jsonDataAccettazione.accettazioneAnagrafica.sesso;
                    me.$refs.cmpAccettazionePostiLettoModalEdit.show(me.jsonDataAccettazione);
                } else {
                    me.saveDimissionieTrasferimento();
                }
            } else {
                if (!me.btnModificaDimissionetrasferimento) {
                    me.$refs.mdlDimissioniTrasferimentiStato.show();
                } else {
                    if (me.jsonData.statoAttuale === "TRASFERITO") {
                        let me = this;
                        me.jsonDataAccettazione.idPresidio = me.jsonData.trasferimentoIdPresidio;
                        me.jsonDataAccettazione.sesso = me.jsonDataAccettazione.accettazioneAnagrafica.sesso;
                        me.$refs.cmpAccettazionePostiLettoModalEdit.show(me.jsonDataAccettazione);
                    } else {
                        me.saveDimissionieTrasferimento();
                    }
                }
            }
        },
        getDataDimissioneTrasferimento() {
            let data = { ...this.jsonData };
            delete data.repartoDimissione;
            if (!this.enableRsaCampiDimissioneAggiuntivi) {
                delete data.modalitaDimissioneRiabilitativa;
                delete data.diagnosiAmministrativaDimissione;
                delete data.listaDiagnosiConcomitanti;
                delete data.lateralita;
                delete data.presenteAlRicovero;
            }
            if (!this.enableRsaDimissioneGestioneAssistenza) {
                delete data.dimissioneGestioneFarmaci;
                delete data.dimissioneGestioneAusili;
                delete data.dimissionePazienteAssenteGiorniSelezionato;
            }
            return data;
        },
        saveDimissionieTrasferimento() {
            this.saveResource(this.pathResource, this.getDataDimissioneTrasferimento(), this.resultResponseSave, null);
        },
        resultResponseSave() {
            this.$bvToast.toast("Salvataggio Avvenuto con successo", {
                title: this.titleModal,
                variant: "success",
                autoHideDelay: 1000,
            });
            this.loadData();
        },
        updateDimissioneeTrasferimento() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id;
            axios
                .put(link, JSON.stringify(me.getDataDimissioneTrasferimento()))
                .then(() => {
                    this.$bvToast.toast("Salvataggio Avvenuto con successo", {
                        title: this.titleModal,
                        variant: "success",
                        autoHideDelay: 1000,
                    });
                    me.loadData();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        onModifica() {
            let me = this;
            if (me.disableCampi) {
                me.disableCampi = !me.disableCampi;
            }
        },
        onCloseModalDimissioniTrasferimentiStato(bvModalEvent) {
            let me = this;
            me.dimissisoneTrasferimentiStatoStorico.statoDataOra = new Date().getTime();
            me.jsonData.storico.push(me.dimissisoneTrasferimentiStatoStorico);
            if (me.dimissisoneTrasferimentiStatoStorico.motivazione === null || me.dimissisoneTrasferimentiStatoStorico.motivazione === "") {
                bvModalEvent.preventDefault();
                me.$bvModal
                    .msgBoxOk("Iserire STATO e/o MOTIVAZIONE", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then(() => {})
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                if (me.dimissisoneTrasferimentiStatoStorico.stato === "ANNULLATO") {
                    me.jsonData.statoAttuale = me.dimissisoneTrasferimentiStatoStorico.stato;
                    me.annullaDimissioneTrasferimento(bvModalEvent);
                } else {
                    me.updateDimissioneeTrasferimento(bvModalEvent);
                }
            }
        },
        onShowModalStorico() {
            let me = this;
            if (me.dimissisoneTrasferimentiStatoStorico.stato === "ANNULLATO") {
                me.dimissisoneTrasferimentiStatoStorico = { stato: "ANNULLATO", motivazione: "", statoDataOra: null };
            } else {
                me.dimissisoneTrasferimentiStatoStorico = { stato: null, motivazione: "", statoDataOra: null };
            }
        },
        onAnnulla() {
            let me = this;
            // me.dimissisoneTrasferimentiStatoStorico = { stato: "ANNULLATO" };
            me.dimissisoneTrasferimentiStatoStorico.stato = "ANNULLATO";
            me.$refs.mdlDimissioniTrasferimentiStato.show();
        },
        annullaDimissioneTrasferimento() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id;
            axios
                .put(link, JSON.stringify(me.getDataDimissioneTrasferimento()))
                .then(() => {
                    this.$bvToast.toast("Salvataggio Avvenuto con successo", { title: this.titleModal, variant: "success", autoHideDelay: 1000 });
                    me.jsonData = { statoAttuale: "", dimissioneMotivoDimissione: "", dimissioneGestioneFarmaci: "", dimissioneGestioneAusili: "" };
                    me.loadData();
                })
                .catch((error) => {
                    me.$emit("afterSaveRequest");
                    let messaggio = error.response ? error.response.data.messaggio : "Errore non gestito";
                    me.$bvModal
                        .msgBoxOk(messaggio, { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", headerClass: "sa-msg-header-danger", footerClass: "p-2 border-top-0", centered: true })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        loadDimissioniTrasferimentiStati() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceDimissioniTrasferimentiStati, {}, me.resultResponseDimissioniTrasferimentiStati, me.resultErrorDimissioniTrasferimentiStati);
        },
        resultResponseDimissioniTrasferimentiStati(response) {
            let me = this;
            me.dimissisoneTrasferimentiStatoOptions = [];
            response.data.data.list.forEach((element) => {
                me.dimissisoneTrasferimentiStatoOptions.push({ text: element.stato, value: element.stato });
            });
            me.dimissisoneTrasferimentiStatoOptions.unshift({ text: "- Selezionare Valore -", value: null });
        },
        resultErrorDimissioniTrasferimentiStati(error) {
            UtilityMixin.methods.messaggeBoxError(this, error);
        },
        setIsDimissioneTrasferimeto(value) {
            let me = this;
            me.isDimissioneTrasferimento = value !== "DIMESSO" && value !== "TRASFERITO";
        },

        notAfter: function (date) {
            return date > Date.now();
        },
        onClickStampa() {
            let me = this;
            me.loadDataResources(me.pathResource + "/printdata/" + me.jsonData.id, null, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampa(error) {
            console.log(error);
        },
        onChangeStatoAttuale(value) {
            let me = this;
            if (value === "TRASFERITO") {
                me.loadStrutture();
            }
        },
        onChangeStrutturaTrasferimento(value) {
            let me = this;
            me.struttureOptions.forEach((element) => {
                if (element.codiceStruttura === value) {
                    me.loadPresidi(element.id);
                    me.jsonData.trasferimentoStrutturaTrasmetimentoCodice = element.codiceStruttura;
                }
            });
        },
        loadStrutture() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStrutture;
            axios
                .get(link)
                .then((response) => {
                    me.struttureOptions = response.data.data;
                    me.struttureOptions.unshift({ codiceStruttura: "", denominazione: "- Seleziona Valore -" });

                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadPresidi(value) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            me.presidiOptions = [];
            let filtroPresidi = { idStruttura: value };
            axios
                .get(link, { params: filtroPresidi })
                .then((response) => {
                    me.presidiOptions = response.data.data.list.filter((element) => element.id !== me.jsonDataAccettazione.idPresidio);
                    me.presidiOptions.unshift({ id: null, denominazione: "- Seleziona Valore -" });
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onChangePresidio(value) {
            let me = this;
            me.presidiOptions.forEach((element) => {
                if (element.id === value) {
                    me.jsonData.trasferimentoPresidioNome = element.denominazione;
                    me.loadSettingsPresidi(element.id);
                }
            });
        },
        loadSettingsPresidi(id) {
            let me = this;
            let params = { idPresidio: id };
            this.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, null);
        },
        resultResponseSettings(response) {
            let me = this;
            me.settingsPresidiOptions = response.data.data.list;
            if (me.settingsPresidiOptions.length === 1) {
                me.jsonData.settingCodice = me.settingsPresidiOptions[0].codice;
                me.jsonData.settingDescrizione = me.settingsPresidiOptions[0].setting;
                me.jsonData.idSetting = me.settingsPresidiOptions[0].idRsaSettings;
                me.loadDataSettingLivelli(me.settingsPresidiOptions[0].idRsaSettings);
            }
        },
        resultErrorSettings(response) {
            UtilityMixin.methods.messaggeBoxError(this, response);
        },
        onUpdateAccettazionePostoLetto(data) {
            let me = this;
            me.jsonData.lettoAccettazioneBean = data;
            me.saveDimissionieTrasferimento();
        },
        loadRegimi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegimi;
            axios
                .get(link)
                .then((response) => {
                    me.regimiOptions = response.data.data.list;
                    if (me.regimiOptions.length === 1) {
                        me.jsonData.regime = me.regimiOptions[0].codice;
                    }
                    me.regimiOptions.unshift({ codice: null, descrizione: "-Seleziona Regime-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        onChangeSettingCodice(value) {
            this.settingsPresidiOptions.forEach((element) => {
                if (element.codice === value) {
                    this.jsonData.settingDescrizione = element.setting;
                    this.jsonData.idSetting = element.idRsaSettings;
                    this.loadDataSettingLivelli(element.idRsaSettings);
                }
            });
        },
        loadDataSettingLivelli(id) {
            this.loadDataResources(this.pathResourceSettingLivelli, { idSetting: id }, this.resultResponseSettingLivelli, null);
        },
        resultResponseSettingLivelli(response) {
            this.settingLivelliOptions = [];

            this.settingLivelliOptions = response.data.data.list;
            if (this.settingLivelliOptions.length === 1) {
                this.jsonData.idSettingLivello = this.settingLivelliOptions[0].id;
                this.jsonData.descrizioneLivello = this.settingLivelliOptions[0].descrizione;
            } else {
                this.settingLivelliOptions.unshift({ id: null, descrizione: "-Seleziona Livello-" });
            }
        },
        onChangeRsaSettingLivelli(value) {
            let me = this;
            me.settingLivelliOptions.forEach((element) => {
                if (element.id === value) {
                    me.jsonData.descrizioneLivello = element.descrizione;
                }
            });
        },
        onClickVisualizzaAllegati(item) {
            let me = this;
            item;
            me.data.idRisorsa = me.jsonData.id;
            me.data.idAnagrafica = me.jsonData.idAccettazione;
            me.$refs.mdlListaAllegati.show();
            // me.$refs.mdlAllegatiList.loadData();
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onClickUndo() {
            let me = this;
            // me.$refs.mdlAllegatiList.loadData();
            me.modalStep = 0;
        },
        onSalvaRichiesta() {
            let me = this;
            let obj = me.getDataPdf(me.data);
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAllegati;
            me.showModalLoading = true;
            axios
                .post(link, obj)
                .then(() => {
                    me.modalStep = 0;
                    me.showModalLoading = false;
                    // me.$refs.mdlAllegatiList.loadData();
                    me.$emit("updateFiles");
                    this.$bvToast.toast(`${this.getLabelTraduora("patient.afa.lblToastSuccessUpload")} - ${this.data.nomeFile}`, {
                        title: "File Upload",
                        autoHideDelay: 2000,
                        variant: "success",
                    });
                })
                .catch((error) => {
                    let message = "";
                    error.response ? error.response.data.messaggio : "Errore non gestito";
                    if (error.response) {
                        message = error.response.data.messaggio ? error.response.data.messaggio : "Codice Errore: " + error.response.status + ", non gestito";
                    }
                    if (error.response) {
                        this.$bvModal
                            .msgBoxOk(message, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then(() => {})
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
        },
        getDataPdf(obj) {
            // let me = this;
            let objPdf = {};
            objPdf.idRisorsa = obj.idRisorsa;
            objPdf.idAnagrafica = this.idAccettazione;
            objPdf.nomeFile = obj.nomeFile;
            objPdf.size = obj.size;
            objPdf.file = obj.file;
            objPdf.tipo = obj.tipo;
            objPdf.dataCaricamento = obj.dataCaricamento;
            objPdf.descrizione = obj.descrizione;
            objPdf.tipoDocumento = obj.tipoDocumento;
            return objPdf;
        },
        onClickAddAllegati() {
            let me = this;
            me.modalStep = 1;
        },
        onClickOk() {
            let me = this;
            me.modalStep = 0;
            me.$refs.mdlListaAllegati.hide();
        },
    },
};
</script>

<style scoped>
.sa-accordion {
    min-height: 0;
}

.sa-accordion-content.sa-tab-scroll {
    min-height: 0;
    overflow-y: auto;
}
</style>
